import { render } from "./Faq.vue?vue&type=template&id=a9c78912"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=a9c78912&lang=css"

import exportComponent from "/builds/octoblue/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__